import { CancelFunctions } from 'components/common/types';
import { HEADERS_CONTENT_TYPE, HTTP_METHODS, URLS } from 'modules/api/constants';
import { OOCReport } from 'components/common/types/ProgrammaticCampaign.types';
import handleRequest from './common';

export const getProgrammaticCampaignsWithOOCFrames = async (cancelFunctions: CancelFunctions): Promise<OOCReport> => {
  const reqOptions = {
    url: URLS().PROGRAMMATIC_CAMPAIGNS_WITH_OOC_FRAMES(),
    method: HTTP_METHODS.GET,
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
  };

  return handleRequest(reqOptions, cancelFunctions, 'PROGRAMMATIC_CAMPAIGNS_WITH_OOC_FRAMES');
};
